import { EmptyState } from '../../components/EmptyState.js';
import { PageHeader } from '../../components/PageHeader.js';

export function InstructorCasesPage() {
  return (
    <div className="page">
      <PageHeader title="Cases" subtitle="Browse and review student cases" />
      <div className="card">
        <EmptyState
          icon={<span aria-hidden>🔍</span>}
          title="No cases to browse"
          description="Approved and pending cases across your cohorts will be searchable here. Use filters by student, specialty, procedure, and clinical site."
        />
      </div>
    </div>
  );
}
